import React from 'react'
import PropTypes from 'prop-types'

const LivePlayIcon = ({ width, height }) => (
  <svg width={width} height={height} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="playButton" clipPath="url(#clip0_572_1811)">
      <path id="Vector" d="M46.4003 23.9996C46.4003 36.3708 36.3713 46.3996 24.0001 46.3996C11.6289 46.3996 1.6001 36.3708 1.6001 23.9996C1.6001 11.6284 11.6289 1.59961 24.0001 1.59961C36.3713 1.59961 46.4003 11.6284 46.4003 23.9996Z" fill="#515151" fillOpacity="0.4" stroke="#F6F6F6" strokeWidth="3.2" />
      <path id="Vector_2" d="M18.2699 33.2858C18.6931 33.2858 19.053 33.113 19.4762 32.8645L31.8149 25.5848C32.6931 25.0555 33 24.7099 33 24.1374C33 23.565 32.6931 23.2194 31.8149 22.701L19.4762 15.4104C19.053 15.162 18.6931 15 18.2699 15C17.4867 15 17 15.6048 17 16.5445V31.7304C17 32.6701 17.4867 33.2858 18.2699 33.2858Z" fill="#F6F6F6" />
    </g>
    <defs>
      <clipPath id="clip0_572_1811">
        <rect width="48" height="48" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

LivePlayIcon.propTypes = {
  width: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  height: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
}

LivePlayIcon.defaultProps = {
  width: 12,
  height: 12,
}

export default LivePlayIcon
